module.exports = __webpack_public_path__ + "static/media/16.4eca0565.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/16.png
// module id = 868
// module chunks = 0